import React from "react";
import { motion } from "framer-motion";
import { fadeUp } from "../../animations/variants";

import { useSelector } from "react-redux";
import { introText } from "../../i18n/intro";

const Intro = () => {
  const lang = useSelector((state) => state.language.lang);
  const t = introText[lang];
  return (
    <section className="py-24 px-6 bg-darkbg text-white overflow-hidden h-screen flex items-center justify-centers">
      <div className="max-w-6xl mx-auto text-center">
        {/* HEADING */}
        <motion.h2
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.3 }}
          className="text-4xl font-heading text-neonYellow animate-neonFlicker"
        >
          {t.title}
        </motion.h2>

        {/* IMAGE */}
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          transition={{ delay: 0.15 }}
          viewport={{ once: true, amount: 0.3 }}
          className="mt-10 w-full overflow-hidden rounded-xl"
        >
          <img
            src="/images/tb1.jpg"
            alt="Career Guidance"
            className="w-full h-[180px] md:h-[300px] object-cover object-center grayscale"
          />
        </motion.div>

        {/* PARAGRAPH */}
        <motion.p
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          transition={{ delay: 0.3 }}
          viewport={{ once: true, amount: 0.3 }}
          className="mt-8 text-lg text-text leading-relaxed"
        >
          {t.description}
        </motion.p>
      </div>
    </section>
  );
};

export default Intro;
